import datapoints from './datapoints';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { lazyShowOptOutDialog } from 'owa-mail-opt-out-view';
import { optIntoJsmvvmClientAndRedirect } from 'owa-mail-optin/lib/utils/mailOptinUtility';
import { setClientOptedIn } from 'owa-mail-store-actions';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action } from 'satcheljs/lib/legacy';
export default action('clientOptOut', datapoints.optOutDatapoint)(function clientOptOut(modulePath) {
    setClientOptedIn(false);
    if (isMailFeatureEnabled('usv-forum') && isUserInSample()) {
        lazyShowOptOutDialog.importAndExecute(modulePath);
    }
    else {
        optIntoJsmvvmClientAndRedirect(modulePath);
    }
});
function isUserInSample() {
    var upn = getUserConfiguration().SessionSettings.UserPrincipalName;
    var day = new Date().toDateString();
    var hash = djb2a(day + upn);
    return hash % 10 === 0;
}
function djb2a(key) {
    var hash = 5381;
    for (var i = 0; i < key.length; i++) {
        hash = (hash * 33) ^ key.charCodeAt(i);
    }
    return hash >>> 0;
}
//# sourceMappingURL=clientOptOut.js.map